module.exports = __webpack_public_path__ + "img/coin.d0c1d48d.svg";